import PropTypes from "prop-types"
import React from "react"
import { map } from "lodash"
import { Table } from "reactstrap"
import { isEmpty } from "lodash"

class ReportResult extends React.Component {
    constructor(props) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.goBack = this.goBack.bind(this)
    }

    handleSubmit(e) {
        e.preventDefault()
        this.props.handleUpload()
    }

    goBack(e) {
        e.preventDefault()
        this.props.goBack()
    }

    render() {
        const validate = this.props.validate

        if (!isEmpty(validate) && validate.errorFlag) {
            return (
                <React.Fragment>
                    <div className="text-center">
                        <div className="mb-4">
                            <h5 className="text-danger">Invalid report</h5>
                            <p>Please reupload after correcting the below errors</p>
                        </div>
                    </div>
                    <div className="table-responsive">
                        <Table className="table table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th>Row no</th>
                                    <th>Column no</th>
                                    <th>Current value</th>
                                    <th>Excepted value</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {map(validate.reportValidateRowList, (row, index) => (
                                    <tr key={index}>
                                        <td>{row.rowNo}</td>
                                        <td>{row.columnNo}</td>
                                        <td>{row.currentValue}</td>
                                        <td>{row.expectedValue}</td>
                                        <td>{row.description}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>

                    <div className="text-end mt-4">
                        {/* <Link to="/report-upload" className="btn btn-danger">
                            Re upload
            </Link> */}
                        <button className="btn btn-danger" onClick={this.goBack}>
                            Go back
          </button>
                    </div>
                </React.Fragment>
            )
        } else if (!isEmpty(validate) && !validate.errorFlag) {
            return (
                <React.Fragment>
                    <div className="text-center">
                        <div className="mb-4">
                            <h5 className="text-success">Report validated successfully</h5>
                            <p>Proceed to upload the report</p>
                        </div>
                    </div>
                    <div className="text-end mt-4">
                        <button className="btn btn-success" onClick={this.handleSubmit}>
                            Upload
          </button>
                    </div>
                </React.Fragment>
            )
        } else {
            return null
        }
    }
}

ReportResult.propTypes = {
    uploadResult: PropTypes.object,
}

export default ReportResult
